const config = {
    // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs,  like '/react/default'

    defaultPath: '/login',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    theme: 'light',
    i18n: 'en', // 'en' - English, 'bn' - Bengali
};

export default config;
